@use 'ui/styles/core-tokens' as core;

.container {
  &Fields {
    display: flex;
    gap: 8px;
    flex-direction: column;

    &Items {
      display: flex;
      gap: 12px;
      flex-direction: row;
      margin-top: 5px;
    }
  }
}
